var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 224.225,
    height: 312.808,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6034.202 2747.31)"
  }, /*#__PURE__*/React.createElement("rect", {
    ry: 10.63,
    rx: 10.63,
    width: 223.228,
    height: 311.811,
    x: 6034.701,
    y: -2746.811,
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.997
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6041.936-2700.745v-2.737h2.66l5.665-29.272h3.223l6.243 29.272h2.148v2.737h-7.318v-2.737h1.977l-.788-4.486h-7.386l-.57 4.486h1.977v2.737zm13.178-10.416l-3.209-15.67-3.006 15.67zM6250.694-2481.066v2.737h-2.661l-5.664 29.272h-3.223l-6.243-29.272h-2.148v-2.737h7.318v2.737h-1.977l.788 4.486h7.385l.57-4.486h-1.976v-2.737zm-13.178 10.416l3.208 15.67 3.007-15.67z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.824 167.75c.015-2.026-1.587-2.064-1.569-.586-.134 7.429-6.416 11.087-10.98 10.219-7.036-1.338-9.282-8.322-9.215-12.435.207-12.697 12.988-22.059 24.52-38.335 8.45 14.69 22.398 26.23 23.223 37.586 1.098 15.098-18.009 20.73-20.737 3.132-.176-1.243-1.64-1.8-1.526-.065.415 4.823-.175 6.832 5.266 18.72h-14.222c3.15-5.555 5.026-12.375 5.24-18.236zM18.022 70.309c.01-.872-.896-.465-1.018-.19-1.163 1.985-2.865 2.447-4.548 1.731-1.667-.709-2.604-2.28-2.454-4.522.31-3.438 3.035-7.2 4.355-9.326a69.037 69.037 0 004.077-7.154c1.697 3.363 2.558 4.32 4.405 7.391 1.626 2.705 3.892 5.353 4.067 8.623 0 2.484-1.046 4.831-3.399 5.259-1.331.242-2.579-.442-3.504-2.037-.282-.406-.849-.195-.839.362.165 2.093.955 3.983 2.83 6.212h-6.888c1.41-1.576 2.85-3.704 2.916-6.35zM206.402 242.884c.01.871-.896.464-1.018.19-1.163-1.986-2.865-2.448-4.548-1.732-1.667.71-2.604 2.28-2.454 4.522.31 3.438 3.035 7.2 4.355 9.327a69.038 69.038 0 014.077 7.154c1.697-3.363 2.558-4.32 4.405-7.392 1.626-2.704 3.892-5.353 4.067-8.622 0-2.485-1.046-4.832-3.4-5.26-1.33-.241-2.578.442-3.503 2.037-.282.407-.849.195-.84-.362.166-2.093.956-3.983 2.83-6.211h-6.887c1.41 1.576 2.849 3.703 2.916 6.349z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAs);
export default __webpack_public_path__ + "static/media/AS.83508bd24a44b51a27b68f0dee67c04f.svg";
export { ForwardRef as ReactComponent };